import React, { useContext, useState } from "react";
import { motion } from "framer-motion";
import { useLanguage } from "../context/LanguageContext";
import Button from "../components/ui/Button";
import { Link } from "react-router-dom";
import AuthContext from "../context/AuthContext";

const bubbleColors = ["#FF640D", "#FFB26F", "#FFD2A7", "#FF8635", "#FFB26F", "#FFD2A7"];

const FaqPage = () => {
    const { token } = useContext(AuthContext);
    const [activeIndex, setActiveIndex] = useState(null);
    const { language } = useLanguage();
    const [bubbleColor, setBubbleColor] = useState(bubbleColors[0]);

    const faqs = {
        en: [
            {
                question: "How do our students register in a language course at Komet Institut?",
                answer: (
                    <>
                        You can register online for the chosen course using our platform.{" "}
                        <Link
                            to={token ? "/me/user/" : "/register"}
                            className="text-blue-500 hover:underline smooth bg-transparent border-none outline-none"
                        >
                            {!token
                                ? "Click here to register"
                                : "you already have aaccount! go to your Dashboard"}
                        </Link>
                        .
                    </>
                ),
            },
            {
                question: "How do our students pay for courses?",
                answer: "You can pay in Cash, Online payments via credit card and Bank Transfer.",
            },
            {
                question: "Is there any discount for the offered courses?",
                answer: "Discounts are available for package bookings. Every 3 levels: 10% off, 6 levels: 15% off, 9 levels: 20% off, 12 levels: 25% off.",
            },
            {
                question: "What do our students do to refund a course?",
                answer: "Refunds depend on request timing. Before the course: full refund. After one class: 30% refund. After two classes: 50% refund. After three classes: No refund.",
            },
            {
                question: "How many students are in each group?",
                answer: "Each group has between 10-12 students, depending on classroom size.",
            },
            {
                question: "What qualifications do our instructors have?",
                answer: "Our instructors are either native speakers or Egyptians qualified under the CEFR language standards.",
            },
            {
                question: "How do I find out about my German language proficiency level?",
                answer: "Before registering, visit our Loran Branch for a placement test to assess your suitable level.",
            },
        ],
        ar: [
            {
                question: "كيف يسجل طلابنا في دورة اللغة بمعهد كوميت؟",
                answer: (
                    <>
                        يمكنك التسجيل عبر الإنترنت للدورة المختارة من خلال منصتنا.{" "}
                        <Link
                            to={token ? "/me/user/" : "/register"}
                            className="text-blue-500 hover:underline smooth bg-transparent border-none outline-none"
                        >
                            {!token
                                ? "اضغط هنا للتسجيل"
                                : "انت بالفعل مٌسجل ! اذهب إلى لوحة التحكم"}
                        </Link>
                        .
                    </>
                ),
            },
            {
                question: "كيف يمكن لطلابنا دفع رسوم الدورات؟",
                answer: "يمكنك الدفع نقدًا أو عبر الإنترنت باستخدام بطاقات الائتمان أو التحويل البنكي.",
            },
            {
                question: "هل هناك أي خصومات على الدورات المقدمة؟",
                answer: "تتوفر الخصومات للحجوزات كحزم: كل 3 مستويات: 10٪ خصم، 6 مستويات: 15٪ خصم، 9 مستويات: 20٪ خصم، 12 مستوى: 25٪ خصم.",
            },
            {
                question: "ماذا يفعل طلابنا لاسترداد رسوم الدورة؟",
                answer: "يعتمد الاسترداد على توقيت الطلب. قبل بدء الدورة: استرداد كامل. بعد درس واحد: 30٪ استرداد. بعد درسين: 50٪ استرداد. بعد ثلاثة دروس: لا يوجد استرداد.",
            },
            {
                question: "كم عدد الطلاب في كل مجموعة؟",
                answer: "يتراوح عدد الطلاب في كل مجموعة بين 10-12 طالبًا، حسب حجم الفصل.",
            },
            {
                question: "ما هي مؤهلات مدربينا؟",
                answer: "مدربونا هم إما متحدثون أصليون أو مصريون مؤهلون وفقًا لمعايير CEFR لتعليم اللغة الألمانية.",
            },
            {
                question: "كيف يمكنني معرفة مستوى إجادتي للغة الألمانية؟",
                answer: "قبل التسجيل، يمكنك زيارة فرع لوران لإجراء اختبار تحديد المستوى المناسب لك.",
            },
        ],
        de: [
            {
                question:
                    "Wie können sich unsere Schüler für einen Sprachkurs am Komet Institut anmelden?",
                answer: (
                    <>
                        Sie können sich online für den gewünschten Kurs über unsere Plattform
                        anmelden.{" "}
                        <Link
                            to={token ? "/me/user/" : "/register"}
                            className="text-blue-500 hover:underline smooth bg-transparent border-none outline-none"
                        >
                            {!token
                                ? "Hier klicken, um sich zu registrieren"
                                : "Sie haben bereits ein Konto! Gehen Sie zu Ihrem Dashboard"}
                        </Link>
                        .
                    </>
                ),
            },
            {
                question: "Wie bezahlen unsere Schüler für die Kurse?",
                answer: "Sie können bar, online per Kreditkarte oder per Banküberweisung bezahlen.",
            },
            {
                question: "Gibt es Rabatte für die angebotenen Kurse?",
                answer: "Rabatte sind für Paketbuchungen verfügbar: 3 Stufen: 10% Rabatt, 6 Stufen: 15% Rabatt, 9 Stufen: 20% Rabatt, 12 Stufen: 25% Rabatt.",
            },
            {
                question: "Wie können unsere Schüler eine Kursrückerstattung beantragen?",
                answer: "Rückerstattungen hängen vom Zeitpunkt der Anfrage ab. Vor Kursbeginn: vollständige Rückerstattung. Nach einer Stunde: 30% Rückerstattung. Nach zwei Stunden: 50% Rückerstattung. Nach drei Stunden: Keine Rückerstattung.",
            },
            {
                question: "Wie viele Schüler sind in jeder Gruppe?",
                answer: "Jede Gruppe besteht aus 10-12 Schülern, abhängig von der Klassengröße.",
            },
            {
                question: "Welche Qualifikationen haben unsere Lehrkräfte?",
                answer: "Unsere Lehrkräfte sind entweder Muttersprachler oder nach den CEFR-Sprachstandards qualifizierte Ägypter.",
            },
            {
                question: "Wie finde ich mein deutsches Sprachniveau heraus?",
                answer: "Vor der Anmeldung können Sie unsere Loran-Filiale besuchen, um einen Einstufungstest zur Ermittlung Ihres geeigneten Niveaus zu absolvieren.",
            },
        ],
    };
    const toggleFAQ = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
        setBubbleColor(bubbleColors[Math.floor(Math.random() * bubbleColors.length)]);
    };

    return (
        <div className="relative negative-nav-margin py-[10rem] min-h-screen flex flex-col items-center px-6  bg-transparent">
            {/* Background Animation - Floating Bubbles */}
            <div className="absolute inset-0 overflow-hidden -z-10">
                {[...Array(7)].map((_, i) => (
                    <motion.div
                        key={i}
                        className="absolute w-32 h-32 opacity-20 rounded-full blur-3xl"
                        initial={{ y: 0 }}
                        animate={{ y: [0, -20, 0] }}
                        transition={{ duration: 6 + i * 0.5, repeat: Infinity, ease: "easeInOut" }}
                        style={{
                            top: `${Math.random() * 80}%`,
                            left: `${Math.random() * 80}%`,
                            backgroundColor: bubbleColor,
                        }}
                    />
                ))}
            </div>

            <h1 className="text-4xl font-bold text-germanAccentText text-center mb-10">
                {language === "en"
                    ? "Frequently Asked Questions"
                    : language === "ar"
                    ? "الأسئلة الشائعة"
                    : "Häufig gestellte Fragen"}{" "}
            </h1>

            <div className="w-full max-w-3xl space-y-6">
                {faqs[language].map((faq, index) => (
                    <div key={index} className="w-full">
                        <button
                            className="w-full flex justify-between items-center text-lg font-semibold text-germanAccentText hover:text-red-600 transition"
                            onClick={() => toggleFAQ(index)}
                        >
                            {faq.question}
                            <motion.span
                                animate={{ rotate: activeIndex === index ? 45 : 0 }}
                                transition={{ type: "spring", stiffness: 500, damping: 20 }}
                                className="text-red-500 text-2xl font-bold"
                            >
                                +
                            </motion.span>
                        </button>

                        <motion.div
                            initial={{ opacity: 0, scale: 0.9, height: 0 }}
                            animate={
                                activeIndex === index
                                    ? { opacity: 1, scale: [0.9, 1.1, 1], height: "100px" }
                                    : { opacity: 0, scale: 0.9, height: 0 }
                            }
                            transition={{
                                type: "spring",
                                stiffness: 120,
                                damping: 10,
                                duration: 0.5,
                            }}
                            className="overflow-hidden text-gray-700 text-base pt-4"
                        >
                            {faq.answer}
                        </motion.div>

                        {/* Divider */}
                        <div className="w-full border-t border-yellow-500 mt-4"></div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FaqPage;
